'use client';

import clsx from 'clsx';
import { motion } from 'motion/react';
import './ScrollShadow.css';

/** Put on sticky first-column cells: the left shadow hangs off their right edge (pass `pinned.start`). */
export const SCROLL_SHADOW_PINNED_START = 'scroll-shadow-pinned-start';
/** Put on sticky header cells: the top shadow hangs off their bottom edge (pass `pinned.top`). */
export const SCROLL_SHADOW_PINNED_TOP = 'scroll-shadow-pinned-top';

/** `strong` for content on a tinted surface (e.g. the job board's grey lanes), where the default shadow gets lost. */

/**
 * A scroll container whose edges show a soft shadow while there's more to scroll that way, fading out over the last
 * stretch before the start or end. CSS only (scroll-driven animations), so it costs nothing per frame.
 *
 *   <ScrollShadow axis="x" className="rounded-xl border border-border">
 *       <table>…</table>
 *   </ScrollShadow>
 *
 *   // Sticky first column: its cells cast the left shadow.
 *   <ScrollShadow axis="x" pinned={{ start: true }}>…<th className={clsx(SCROLL_SHADOW_PINNED_START, 'sticky left-0')}>…
 */
export const ScrollShadow = ({
  axis = 'x',
  pinned,
  intensity = 'default',
  className,
  scrollerClassName,
  scrollerProps,
  ref,
  children,
  'data-testid': testId
}) => {
  const x = axis !== 'y';
  const y = axis !== 'x';
  return <div className={clsx('scroll-shadow', className)} data-intensity={intensity === 'default' ? undefined : intensity} data-testid={testId}>
            <motion.div {...scrollerProps} ref={ref} className={clsx('scroll-shadow-scroller', x ? 'overflow-x-auto' : 'overflow-x-hidden', y ? 'overflow-y-auto' : 'overflow-y-hidden', scrollerClassName)}>
                {children}
            </motion.div>
            {x && !pinned?.start && <div aria-hidden className="scroll-shadow-edge" data-edge="start" />}
            {x && <div aria-hidden className="scroll-shadow-edge" data-edge="end" />}
            {y && !pinned?.top && <div aria-hidden className="scroll-shadow-edge" data-edge="top" />}
            {y && <div aria-hidden className="scroll-shadow-edge" data-edge="bottom" />}
        </div>;
};